import styled from "styled-components"

import { maxWidth } from "utils"

export const Title = styled.h2``

export const SubTitle = styled.h4``

export const Text = styled.p`
  font-size: 1.6rem;

  ${maxWidth.mobile`
    font-size: 1.2rem;
  `}
`

export const Name = styled.p`
  max-width: 75%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  line-height: 1.5rem;
  font-weight: 500;
  letter-spacing: 0.25px;
`
